import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMatchUpdates } from "../../lib/leaderboardApi";
import { directorPath } from "./directorPortal";
import { updateTime } from "./MatchUpdates";

export default function PublicationProgress({ match, portal, dirty }) {
  const [review, setReview] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    setReview(null); setFailed(false);
    Promise.resolve().then(() => getMatchUpdates(match.matchId, match.family, { review: true }))
      .then(result => { if (active && result?.data) setReview(result.data); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [match.matchId, match.family, portal.revision]);
  const announcement = review?.pending ? "Announcement still delivering" : review?.changes?.length ? "Changes not yet announced"
    : review?.lastAnnouncementAt ? "Published details announced" : review ? "No announcement yet" : failed ? "Announcement status unavailable" : "Checking announcement status…";
  return <div className="dp-publication-progress" aria-label="Publication progress">
    <div><span>1 · Draft</span><strong>{dirty ? "Unsaved changes" : portal.savedAt ? "Draft saved" : "Draft not saved"}</strong></div>
    <div><span>2 · Public page</span><strong>{portal.publishedAt ? `Last published ${updateTime(portal.publishedAt)}` : "Information not published"}</strong></div>
    <div><span>3 · Competitor update</span><strong>{announcement}</strong><Link className="dp-link" to={`${directorPath(match)}/updates`}>Review & notify</Link></div>
  </div>;
}
